<div class="holiday-nudge">
    <div class="holiday-close">
        <button (click)="dismiss()"> 
            <img class="nudge-close" src="assets/icons/close.svg" /> 
        </button> 
    </div>
    <div class="holiday-title">
        <img class="nudge-icon" src="{{ data.icon }}"/>
        <p class="nudge-title"> {{ data.title }} </p>
    </div>
    <div *ngIf="data.message" class="holiday-body">
        <p class="nudge-text">
            <span [innerHTML]="data.message"></span>
        </p>
    </div>
    <div class="holiday-end">
        <p *ngIf="totalMessages > 1" class="pending-messages">
            {{ data.currentNudge }}/{{ totalMessages }} 
        </p>
    </div>
</div>
